var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"block"},[_c('line',{attrs:{"x1":"0","y1":"0","x2":"100%","y2":"100%","stroke":"currentColor"}}),_c('line',{attrs:{"x1":"0","y1":"100%","x2":"100%","y2":"0%","stroke":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }